// extracted by mini-css-extract-plugin
export var button = "_dp-7";
export var buttonRow = "_dp-6";
export var fadeIn = "_dp-1";
export var gradient = "_dp-0";
export var panel = "_dp-2";
export var panelIn = "_dp-3";
export var subtitle = "_dp-5";
export var title = "_dp-4";